import type { ArvoreContentType } from 'api/data.types'
import {
  INTERMEDIATE_DETAILS_ARTICLE_PATH,
  INTERMEDIATE_DETAILS_BOOK_PATH
} from 'routes/paths'
import { useFeatureTogglesStore } from 'stores/featureTogglesStore'

const NEXTJS_BOOK_INTERMEDIATE_PATH = (slug: string) =>
  `/app-v2/book/intermediate/${slug}`

const NEXTJS_VIDEO_PATH = (slug: string) => `/app-v2/videos/${slug}`

const shouldUseNextjsBookIntermediate = () => {
  const { featureToggles } = useFeatureTogglesStore.getState()
  return (
    featureToggles?.biblionGeneral === true ||
    featureToggles?.seedPrPoc === true
  )
}

const redirectToIntermediatePage = (
  history,
  contentType: ArvoreContentType,
  slugOrId: string | number
) => {
  if (contentType === 'article') {
    return history.push(INTERMEDIATE_DETAILS_ARTICLE_PATH(slugOrId))
  }

  if (contentType === 'video') {
    window.location.href = NEXTJS_VIDEO_PATH(slugOrId.toString())
    return
  }

  if (shouldUseNextjsBookIntermediate()) {
    window.location.href = NEXTJS_BOOK_INTERMEDIATE_PATH(slugOrId.toString())
    return
  }

  return history.push(INTERMEDIATE_DETAILS_BOOK_PATH(slugOrId.toString()))
}

export { redirectToIntermediatePage, shouldUseNextjsBookIntermediate }
